import type { ZodError } from 'zod'

export class JSONParseError extends Error {
  constructor() {
    super('Invalid JSON')
  }

  get description() {
    return 'The provided string is not valid JSON.'
  }
}

export class SchemaParseError extends Error {
  errors: ZodError
  constructor(errors: ZodError) {
    super('Schema parsing error')
    this.errors = errors
  }

  get description() {
    return this.errors.errors
      .map((e) => `${e.path.join('.')} - ${e.message}`)
      .join('\n')
  }
}
